;(function () {
  'use strict'
  angular
    .module('contrast.technology')
    .factory('TechnologyFactory', ['$http', 'UserService', TechnologyFactory])

  function TechnologyFactory($http, UserService) {
    var service = {
      getTechs: getTechs
    }

    return service

    function getTechs(languages) {
      return $http.get(UserService.buildAPIUrl('/techs'), {
        params: {
          languages: languages ? languages.join() : ''
        }
      })
    }
  }
})()
